module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs-slim"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    directives: [{
      name: "collapse-stepper",
      rawName: "v-collapse-stepper"
    }],
    staticClass: "panel-group panel-group-stepper",
    attrs: {
      "id": "create-job",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "stepOne"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#create-job",
      "href": "#job-details",
      "aria-expanded": "true",
      "aria-controls": "job-details"
    }
  }, [_c('span', {
    staticClass: "stepper-number stepper-active",
    class: {
      'stepper-error': _vm.errors.any()
    }
  }, [_vm._v("1")]), _vm._v(" Job Details\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "job-details",
      "role": "tabpanel",
      "aria-labelledby": "stepOne"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('user_id')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('selectize', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.$user.isAdminOrCoordinator
      }),
      expression: "{ required: $user.isAdminOrCoordinator }"
    }],
    attrs: {
      "options": _vm.userOptions,
      "fetch-results": _vm.fetchUserResults,
      "name": "user_id"
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Coordinator")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.coordinatorOptions,
      "fetch-results": _vm.fetchCoordinatorResults,
      "name": "coordinator_id"
    },
    model: {
      value: (_vm.coordinator),
      callback: function($$v) {
        _vm.coordinator = $$v
      },
      expression: "coordinator"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Date Range")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('date-range', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    attrs: {
      "name": "start_date",
      "single-date-picker": true,
      "opens": "right"
    },
    model: {
      value: (_vm.startAt),
      callback: function($$v) {
        _vm.startAt = $$v
      },
      expression: "startAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('date-range', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    attrs: {
      "name": "end_date",
      "single-date-picker": true,
      "opens": "right"
    },
    model: {
      value: (_vm.endAt),
      callback: function($$v) {
        _vm.endAt = $$v
      },
      expression: "endAt"
    }
  })], 1)])])]), _vm._v(" "), _c('h3', [_vm._v("What do you need transported?")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantity (t)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantity),
      expression: "quantity"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Quantity (t)",
      "min": "0"
    },
    domProps: {
      "value": (_vm.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantity = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('commodity')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('selectize', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.$user.isAdminOrCoordinator
      }),
      expression: "{ required: $user.isAdminOrCoordinator }"
    }],
    attrs: {
      "options": _vm.commodityOptions,
      "name": "commodity"
    },
    model: {
      value: (_vm.commodity),
      callback: function($$v) {
        _vm.commodity = $$v
      },
      expression: "commodity"
    }
  })], 1)])])]), _vm._v(" "), _c('h3', [_vm._v("Do you have additional reference details for this job?")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Order Reference")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderReference),
      expression: "orderReference"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Order Reference",
      "name": "order_reference"
    },
    domProps: {
      "value": (_vm.orderReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderReference = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pickup Reference")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupReference),
      expression: "pickupReference"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pickup Reference",
      "name": "pickup_reference"
    },
    domProps: {
      "value": (_vm.pickupReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupReference = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Delivery Reference")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryReference),
      expression: "deliveryReference"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Delivery Reference",
      "name": "job_reference"
    },
    domProps: {
      "value": (_vm.deliveryReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryReference = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "location-details",
      "role": "tabpanel",
      "aria-labelledby": "stepTwo"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Location From")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.locationOptionsFrom,
      "fetch-results": _vm.fetchLocationResults('from'),
      "name": "location_from"
    },
    model: {
      value: (_vm.locationFrom),
      callback: function($$v) {
        _vm.locationFrom = $$v
      },
      expression: "locationFrom"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-6"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-success btn-new-location",
    attrs: {
      "href": "#drawer-location-add",
      "data-toggle": "drawer",
      "aria-foldedopen": "false",
      "aria-controls": "drawer-location-add"
    },
    on: {
      "click": _vm.handleAddFromLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New\n                        ")])])]), _vm._v(" "), (_vm.haveLocationFrom) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-6"
  }, [_c('div', {
    staticClass: "card card-location-overview"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.locationFromDecorated.name))]), _vm._v(" "), (_vm.locationFromDecorated.address) ? [_vm._v(" - " + _vm._s(_vm.locationFromDecorated.address))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.locationFromDecorated.contact_name) ? _c('strong', [_vm._v(_vm._s(_vm.locationFromDecorated.contact_name))]) : _vm._e(), _vm._v(" "), (_vm.locationFromDecorated.contact_phone) ? [_vm._v(" - " + _vm._s(_vm.locationFromDecorated.contact_phone))] : _vm._e()], 2), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs btn-info btn-edit-location",
    attrs: {
      "href": "#drawer-location-add",
      "data-toggle": "drawer",
      "aria-foldedopen": "false",
      "aria-controls": "drawer-location-add"
    },
    on: {
      "click": _vm.handleEditFromLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Edit\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Location To")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.locationOptionsTo,
      "fetch-results": _vm.fetchLocationResults('to'),
      "name": "location_to"
    },
    model: {
      value: (_vm.locationTo),
      callback: function($$v) {
        _vm.locationTo = $$v
      },
      expression: "locationTo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-6"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-success btn-new-location",
    attrs: {
      "href": "#drawer-location-add",
      "data-toggle": "drawer",
      "aria-foldedopen": "false",
      "aria-controls": "drawer-location-add"
    },
    on: {
      "click": _vm.handleAddToLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New\n                        ")])])]), _vm._v(" "), (_vm.haveLocationTo) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-6"
  }, [_c('div', {
    staticClass: "card card-location-overview"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.locationToDecorated.name))]), _vm._v(" "), (_vm.locationToDecorated.address) ? [_vm._v(" - " + _vm._s(_vm.locationToDecorated.address))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.locationToDecorated.contact_name) ? _c('strong', [_vm._v(_vm._s(_vm.locationToDecorated.contact_name))]) : _vm._e(), _vm._v(" "), (_vm.locationToDecorated.contact_phone) ? [_vm._v(" - " + _vm._s(_vm.locationToDecorated.contact_phone))] : _vm._e()], 2), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs btn-info btn-edit-location",
    attrs: {
      "href": "#drawer-location-add",
      "data-toggle": "drawer",
      "aria-foldedopen": "false",
      "aria-controls": "drawer-location-add"
    },
    on: {
      "click": _vm.handleEditToLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Edit\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "rate-and-job-notes",
      "role": "tabpanel",
      "aria-labelledby": "stepThree"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v("Rate")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("How much would you like to pay per tonne for your transport. This price is subject to change during the job approval process.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "0.00",
      "step": "0.01",
      "min": "0"
    },
    domProps: {
      "value": (_vm.rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rate = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("/ tonne")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary m-t-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestPrice),
      expression: "requestPrice"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-price-request",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.requestPrice) ? _vm._i(_vm.requestPrice, null) > -1 : (_vm.requestPrice)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.requestPrice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.requestPrice = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.requestPrice = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.requestPrice = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-price-request"
    }
  }, [_vm._v("\n                            Request Price\n                          ")])])])]), _vm._v(" "), (_vm.$user.isAdmin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary m-t-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicJob),
      expression: "publicJob"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-job-public",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.publicJob) ? _vm._i(_vm.publicJob, null) > -1 : (_vm.publicJob)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.publicJob,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.publicJob = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.publicJob = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.publicJob = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-job-public"
    }
  }, [_vm._v("\n                              This job is available on the jobs board\n                            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('h3', [_vm._v("Job Notes")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Let us know of any specific requirements you have.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "placeholder": "Notes",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.$user.isClientOrCarrier) ? _c('div', [_c('h3', [_vm._v("Job Notifications")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("What notifications do you want to receive for this job.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-lg"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyJobStatus),
      expression: "notifyJobStatus"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-email",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyJobStatus) ? _vm._i(_vm.notifyJobStatus, null) > -1 : (_vm.notifyJobStatus)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyJobStatus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyJobStatus = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyJobStatus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyJobStatus = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-email"
    }
  }, [_vm._v("\n                            Notify me of job status updates\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyLoadDeliveries),
      expression: "notifyLoadDeliveries"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-notify-email-delivery",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyLoadDeliveries) ? _vm._i(_vm.notifyLoadDeliveries, null) > -1 : (_vm.notifyLoadDeliveries)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyLoadDeliveries,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyLoadDeliveries = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyLoadDeliveries = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyLoadDeliveries = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-notify-email-delivery"
    }
  }, [_vm._v("\n                            Notify me of load deliveries\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#create-job",
      "aria-controls": "rate-and-job-notes",
      "aria-expanded": "true",
      "data-target": "#location-details"
    }
  }, [_vm._v("\n                        Back\n                      ")]), _vm._v(" "), (_vm.creatingNewJob) ? _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSubmitJob,
      "type": "success"
    }
  }, [_vm._v("\n                        Submit Job\n                      ")]) : _c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSaveJob,
      "type": "success"
    }
  }, [_vm._v("\n                        Save Job\n                      ")])], 1)])])])])])]), _vm._v(" "), (_vm.addingOrEditingLocation) ? _c('location-drawer', {
    attrs: {
      "existing-location": _vm.locationBeingEdited,
      "done": _vm.locationDoneCallback,
      "closed": _vm.locationDrawerClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#create-job",
      "aria-controls": "job-details",
      "aria-expanded": "true",
      "data-target": "#location-details"
    }
  }, [_vm._v("\n                        Next\n                      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "stepTwo"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#create-job",
      "href": "#location-details",
      "aria-expanded": "false",
      "aria-controls": "location-details"
    }
  }, [_c('span', {
    staticClass: "stepper-number"
  }, [_vm._v("2")]), _vm._v(" Location Details\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#create-job",
      "aria-controls": "location-details",
      "aria-expanded": "true",
      "data-target": "#job-details"
    }
  }, [_vm._v("\n                        Back\n                      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#create-job",
      "aria-controls": "location-details",
      "aria-expanded": "true",
      "data-target": "#rate-and-job-notes"
    }
  }, [_vm._v("\n                        Next\n                      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "stepThree"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#create-job",
      "href": "#rate-and-job-notes",
      "aria-expanded": "false",
      "aria-controls": "rate-and-job-notes"
    }
  }, [_c('span', {
    staticClass: "stepper-number"
  }, [_vm._v("3")]), _vm._v(" Rate and Job Notes\n                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-a614aa6a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/Form.vue
// module id = 1068
// module chunks = 0